module.exports = __webpack_public_path__ + "img/elec_shishi.b8aa1a03.png";